<template>
  <AppAdsense
    ad-class="google-ad--header"
    ad-style="display:block"
    ad-client="ca-pub-9118328092882671"
    ad-slot="7769414899"
  />
</template>
